type WidgetIcon = {
  title: string;
  url: string;
  enabled: boolean;
  type: string;
};

type ContentCategory = {
  name: string;
  value: string;
};

type Page = {
  name: string;
  value: string;
};

enum PageType {
  Url = 'Url',
  Page = 'Page',
  IDs = 'IDs',
}

type NavEntry = {
  id: string;
  createdDate: number;
  lastModifiedDate: number;
  version: number;
  title: string;
  locale: string;
  url: string;
  pageType: PageType;
  contentCategory: ContentCategory | null;
  page: Page | null;
  icon: WidgetIcon;
  openInNewTab: boolean;
  hideFromLoggedOut: boolean;
  enabledOnDesktop: boolean;
  enabledOnMobile: boolean;
  desktopPosition: number;
  mobilePosition: number;
};

type SportsbookNavigationMenuProps = {
  entries: NavEntry[];
  isUserLoggedIn?: boolean;
  onNavigate?: (entry: NavEntry) => void;
  className?: string;
};

type RouteParams = {
  page?: string;
  eventId?: number;
  sportId?: number;
  racingType?: number;
  categoryIds?: number[];
  championshipIds?: number[];
  catId?: number;
  champId?: number;
  event?: { id: number };
};

type NavigationEntry = {
  id: string;
  name: string;
  page: string;
  desktopPosition: number;
};

type NavigationMenuProps = {
  entries: NavigationEntry[];
  activePage: string;
  onNavigate: (page: string) => void;
  className?: string;
};

type NavigationHookParams = {
  sdk: unknown;
  entries: NavigationEntry[];
  page: string;
  onRouteChange?: (routeData: unknown) => void;
};

type NavigationUtils = {
  filterAndSortEntries: (entries: NavigationEntry[]) => NavigationEntry[];
  findTargetEntry: (entries: NavigationEntry[], page: string) => NavigationEntry | undefined;
  performNavigation: (sdk: unknown, targetEntry: NavigationEntry, onRouteChange?: (routeData: unknown) => void) => Promise<void>;
  performInitialNavigation: (params: NavigationHookParams) => Promise<void>;
  mapPageValue: (page: string) => string;
  updateUrlParams: (page: string) => void;
};

type SportsbookMenuEntry = {
  id: string;
  page: string;
  desktopPosition: number;
  parentId?: string;
  weight?: number;
  name: string;
  displayName: string;
};

type SportsbookMenuData = {
  menu: SportsbookMenuEntry[];
};

export {
  PageType,
  type ContentCategory,
  type NavEntry,
  type NavigationEntry,
  type NavigationHookParams,
  type NavigationMenuProps,
  type NavigationUtils,
  type Page,
  type RouteParams,
  type SportsbookMenuData,
  type SportsbookMenuEntry,
  type SportsbookNavigationMenuProps,
  type WidgetIcon,
};
